<glxy-form-field>
  @if (integration(); as integ) {
    <glxy-label>{{
      'AI_ASSISTANT.SETTINGS.INTEGRATIONS.LABEL' | translate: { displayName: integ.displayName }
    }}</glxy-label>
  }

  <mat-select
    [value]="selectedConnection()"
    [compareWith]="compareConnections"
    (selectionChange)="onSelection($event)"
    [disabled]="configurationForm().disabled"
  >
    @if (integration(); as integ) {
      @for (connection of connections(); track connection) {
        <mat-option [value]="connection">
          {{ connection.label }}
        </mat-option>
      }

      <mat-option [value]="null" (click)="goToIntegration(integ.integrationId)" class="create-new-calendar">
        <span class="option-text">
          {{ 'AI_ASSISTANT.SETTINGS.INTEGRATIONS.CONNECT' | translate: { displayName: integ.displayName } }}
        </span>
      </mat-option>
    }
  </mat-select>
</glxy-form-field>
